import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import courseActions from '@redux/course/actions';
import { RootState } from '@redux/reducer';

const { fetchCourseEnrollmentAction } = courseActions;

const useCourseEnrollment = () => {
  const dispatch = useDispatch();
  const { courseEnrollmentState } = useSelector((state: RootState) => ({
    courseEnrollmentState: state.Course.get('courseEnrollmentState'),
  }));

  const { data: courseEnrollmentData } = courseEnrollmentState;

  const handleFetchCourseEnrollment = (courseId: number) => {
    dispatch(fetchCourseEnrollmentAction.request({ courseId }));
  };

  const handleResetCourseEnrollment = () => {
    dispatch(fetchCourseEnrollmentAction.reset());
  };

  const { enrollmentId, courseEnrollmentStatus, hasEnrolled, canDiscuss } = useMemo(() => {
    return {
      enrollmentId: courseEnrollmentData?.enrollmentId,
      courseEnrollmentStatus: courseEnrollmentData?.enrollmentStatus,
      hasEnrolled: courseEnrollmentData?.hasEnrolled,
      canDiscuss: courseEnrollmentData?.canDiscuss,
    };
  }, [courseEnrollmentData]);

  return {
    enrollmentId,
    courseEnrollmentStatus,
    hasEnrolled,
    canDiscuss,
    handleFetchCourseEnrollment,
    handleResetCourseEnrollment,
  };
};

export default useCourseEnrollment;
